import { useState, useEffect } from "react";
import { Box, Grid, GridItem, VStack, Button, Text } from "@chakra-ui/react";
import DynamicFormContainer from "components/CommonForm/DynamicFormContainer";
import ProfileCard from "components/CommonForm/ProfileCard";

const formConfig = [
  {
    id: "basicInfo",
    title: "Βασικές Πληροφορίες",
    fields: [
      { name: "fullname", label: "Ονοματεπώνυμο", type: "text", required: true, gridSize: 6 },
      { name: "company", label: "Όνομα Εταιρείας", type: "text", gridSize: 6 },
      { name: "email", label: "Email", type: "email", required: true, gridSize: 6, validation: "email" },
      { name: "phone", label: "Τηλέφωνο Επικοινωνίας", type: "tel", required: true, gridSize: 6, validation: "phone" },
      { name: "second_phone", label: "Δεύτερο Τηλέφωνο", type: "tel", gridSize: 6, validation: "phone" },
      { name: "registration", label: "Αριθμός Εγγραφής", type: "text", gridSize: 6 },
      { name: "address", label: "Διεύθυνση", type: "textarea", gridSize: 12 },
    ],
  },
  {
    id: "customerOptions",
    title: "Επιλογές Πελάτη",
    fields: [
      { name: "pylonCode", label: "Κωδικός PYLON", type: "text", gridSize: 6 },
      {
        name: "customerCategory",
        label: "Κατηγορία Πελάτη",
        type: "select",
        options: ["Daily", "Weekly"],
        gridSize: 6,
      },
      {
        name: "startTime",
        label: "Ώρα Έναρξης",
        type: "time",
        gridSize: 6,
        required: true,
        conditional: (formData) => formData.customerCategory === "Daily",
      },
      {
        name: "endTime",
        label: "Ώρα Λήξης",
        type: "time",
        gridSize: 6,
        required: true,
        conditional: (formData) => formData.customerCategory === "Daily",
      },
      {
        name: "driver",
        label: "Επιλέξτε Οδηγό",
        type: "select",
        options: ["Driver 1", "Driver 2", "Driver 3"],
        gridSize: 6,
      },
      {
        name: "Add favourite products",
        label: "Add favourite products",
        type: "multi-select",
        options: ["products 1", "products 2", "products 3", "products 4"],
        gridSize: 12,
      },
    ],
  },
  {
    id: "passwordSection",
    title: "Κωδικός εισόδου στην εφαρμογή",
    fields: [
      { name: "currentPassword", label: "Τωρινός κωδικός εισόδου", type: "password", required: true, gridSize: 12 },
      { name: "newPassword", label: "Νέος κωδικός εισόδου", type: "password", required: true, gridSize: 12 },
      { name: "confirmPassword", label: "Επιβεβαίωση νέου κωδικού", type: "password", required: true, gridSize: 12 },
    ],
  },
];

const AddCustomer = ({ customerData }) => {
    const [formData, setFormData] = useState({
        fullname: customerData?.fullname || "",
        company: customerData?.company || "",
        email: customerData?.email || "",
        phone: customerData?.phone || "",
        second_phone: customerData?.second_phone || "",
        registration: customerData?.registration || "",
        address: customerData?.address || "",
        pylonCode: customerData?.pylonCode || "",
        customerCategory: customerData?.customerCategory || "",
        startTime: customerData?.startTime || "",
        endTime: customerData?.endTime || "",
        driver: customerData?.driver || "",
        selectedDrivers: customerData?.selectedDrivers || [],
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    
      const [errors, setErrors] = useState({});
    
      useEffect(() => {
        if (customerData) {
          setFormData((prevData) => ({
            ...prevData,
            fullname: customerData.fullname || prevData.fullname,
            company: customerData.company || prevData.company,
            email: customerData.email || prevData.email,
            phone: customerData.phone || prevData.phone,
            second_phone: customerData.second_phone || prevData.second_phone,
            registration: customerData.registration || prevData.registration,
            address: customerData.address || prevData.address,
            pylonCode: customerData.pylonCode || prevData.pylonCode,
            customerCategory: customerData.customerCategory || prevData.customerCategory,
            startTime: customerData.startTime || prevData.startTime,
            endTime: customerData.endTime || prevData.endTime,
            driver: customerData.driver || prevData.driver,
            selectedDrivers: customerData.selectedDrivers || prevData.selectedDrivers,
          }));
        }
      }, [customerData]);

  const validateForm = () => {
    let newErrors = {};
  
    formConfig.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.required && !formData[field.name]) {
          newErrors[field.name] = "Αυτό το πεδίο είναι υποχρεωτικό";
        }
        if (field.validation === "email" && formData[field.name] && !/\S+@\S+\.\S+/.test(formData[field.name])) {
          newErrors[field.name] = "Μη έγκυρη διεύθυνση email";
        }
        if (field.validation === "phone" && formData[field.name] && !/^\d{10}$/.test(formData[field.name])) {
          newErrors[field.name] = "Το τηλέφωνο πρέπει να έχει 10 ψηφία";
        }
      });
    });
  
    console.log("Checking if customerCategory is 'daily':", formData.customerCategory === "daily"); // ✅ Debugging
  
    if (formData.customerCategory === "daily") {
      console.log("Validation triggered for startTime & endTime"); // ✅ Debugging
      if (!formData.startTime) {
        newErrors.startTime = "Αυτό το πεδίο είναι υποχρεωτικό";
      }
      if (!formData.endTime) {
        newErrors.endTime = "Αυτό το πεδίο είναι υποχρεωτικό";
      }
    }
  
    if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Οι κωδικοί δεν ταιριάζουν";
    }
  
    console.log("Validation Errors:", newErrors); // ✅ Debugging
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  
  
  
  const handleSubmit = () => {
    console.log("Submit button clicked");
    console.log("Current FormData:", JSON.stringify(formData, null, 2));  // ✅ Check if formData has correct values
  
    if (validateForm()) {
      console.log("Final Payload:", JSON.stringify(formData, null, 2));
    }
  };
  const isEdit = !!formData.fullname || !!formData.email || !!formData.phone;



  return (
    <Box  mt={24}>
    {isEdit && (
  <ProfileCard  
    name={formData.fullname || "ΑΘΑΝΑΣΟΠΟΥΛΟΣ ΓΕΥΣΗΔΡΟΜΙΟ"}
    email={formData.email || "athanasopoulos0689@gmail.com"}
    profileImage=""
    status="Ενεργός πελάτης"
  />
)}

      <Grid  mt ={4} templateColumns="65% 33%" gap={6} alignItems="start">
        <GridItem>
          <VStack spacing={6} align="stretch">
            {formConfig.slice(0, 2).map((card) => (
              <DynamicFormContainer
                key={card.id}
                title={card.title}
                cardData={card}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
              />
            ))}
          </VStack>
        </GridItem>

        <GridItem>
          <DynamicFormContainer
            title={formConfig[2].title}
            cardData={formConfig[2]}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          />
        </GridItem>
      </Grid>

      {Object.keys(errors).length > 0 && (
        <Text color="red.500" mt={4}>
          Υπάρχουν σφάλματα στη φόρμα. Ελέγξτε τα πεδία και προσπαθήστε ξανά.
        </Text>
      )}

      <Button  mt={6} variant="no-hover"
          bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          w="125px"
          h="35px"
          color="#fff"
          fontSize="xs"
          fontWeight="bold"
          alignSelf={{ sm: "flex-start", lg: null }}
          mb={{ sm: "12px", md: "0px" }} onClick={handleSubmit}>
        Υποβολή
      </Button>
    </Box>
  );
};

export default AddCustomer;
